import React from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../api'

const LogoutButton = () => {
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await api.post('/api/auth/logout');
      localStorage.removeItem('user');
      
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="px-3 py-1 bg-red-500/10 text-red-500 rounded-md text-sm hover:bg-red-500/20 transition-colors"
    >
      Logout
    </button>
  )
}

export default LogoutButton